import { Storage as TossStorage } from '@apps-in-toss/web-framework';
import { isInTossApp } from './env';

// 토스 앱: SDK Storage / 웹 개발: localStorage
// 모든 메소드는 Promise 반환 (SDK API 일관성)
export const storage = {
  getItem: async (key: string): Promise<string | null> => {
    if (isInTossApp()) {
      try { return await TossStorage.getItem(key); }
      catch { /* fallthrough */ }
    }
    try { return localStorage.getItem(key); } catch { return null; }
  },

  setItem: async (key: string, value: string): Promise<void> => {
    if (isInTossApp()) {
      try { await TossStorage.setItem(key, value); return; }
      catch { /* fallthrough */ }
    }
    try { localStorage.setItem(key, value); } catch { /* quota / disabled */ }
  },

  removeItem: async (key: string): Promise<void> => {
    if (isInTossApp()) {
      try { await TossStorage.removeItem(key); return; }
      catch { /* fallthrough */ }
    }
    try { localStorage.removeItem(key); } catch { /* noop */ }
  },

  clearItems: async (): Promise<void> => {
    if (isInTossApp()) {
      try { await TossStorage.clearItems(); return; }
      catch { /* fallthrough */ }
    }
    try { localStorage.clear(); } catch { /* noop */ }
  },
};
